import { gql } from 'apollo-angular';

export const APTITUDE_USER_APTITUDE_ORGS = gql`
  query AptitudeUserAptitudeOrgs($aptitudeToken: String!) {
    aptitudeUserAptitudeOrgs(aptitudeToken: $aptitudeToken) {
      id
      name
    }
  }
`;

export type AptitudeUserAptitudeOrgsVariables = {
  aptitudeToken: string;
};
